// extracted by mini-css-extract-plugin
export var container = "Discrepancies-module--container--yRmdl";
export var discrepancy = "Discrepancies-module--discrepancy--mFk-H";
export var discrepancyModal = "Discrepancies-module--discrepancyModal--sAG8L";